module.exports = __webpack_public_path__ + "static/media/light-mode-image.bebb88eb.svg";